import { valueAccessor } from '@syncfusion/ej2-react-grids'
import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from 'Tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'Tyan/public/utility/formValues'
import CostBearingDepartmentDiv from 'Tyan/menus/AdvanceExpenseManageMent/CostBearingDepartmentDiv'
import AdvanceApplicationSelectDiv from 'Tyan/menus/AdvanceExpenseManageMent/AdvanceApplicationSelectDiv'
import ExpenseDetailDiv from 'Tyan/menus/AdvanceExpenseManageMent/ExpenseDetailDiv'
import EntrustedTestContractSelectDiv from 'Tyan/menus/AdvanceExpenseManageMent/EntrustedTestContractSelectDiv'
import AdvanceOrder from 'Tyan/menus/AdvanceExpenseManageMent/AdvanceOrder'
import InvoiceDiv from 'Tyan/menus/AdvanceExpenseManageMent/InvoiceDiv'
import BTExpenseDtailDiv from 'Tyan/menus/AdvanceExpenseManageMent/BTExpenseDtailDiv'
import SelectPurchaseOrderNoDiv from 'Tyan/menus/AdvanceExpenseManageMent/SelectPurchaseOrderNoDiv'
import SelectOutApplyNumberDiv from 'Tyan/menus/AdvanceExpenseManageMent/SelectOutApplyNumberDiv'
import LeaveApplyDetail from 'Tyan/menus/LeaveManagement/LeaveApplyDetail'
import FlowRecordDetail from 'Tyan/menus/OAManagement/FlowRecordDetail'


import { exportFile } from 'Tyan/public/index'

class ExpenseApply extends React.Component {
	state = {
		changedValues基本信息: {},
		id: (this.props.match && this.props.match.params && this.props.match.params.id) || this.props.id || 0,
		expenseName: decodeURIComponent(this.props.match.params.expenseName) || ''
	}

	SettingsDiv = {
		'成本承担部门': CostBearingDepartmentDiv,
		'预支申请单': AdvanceApplicationSelectDiv,
		'费用明细': ExpenseDetailDiv,
		'发票明细': InvoiceDiv,
		'委外测试合同': EntrustedTestContractSelectDiv,
		'出差/外训费用明细': BTExpenseDtailDiv,
	}

	componentDidMount = () => {
		const { id } = this.state
		this.handlerInitValue(id)
	}

	componentWillUnmount = () => {
		this.unmount = true
	}

	handlerInitValue = (id) => {
		const { taskName, expenseName } = this.state
		// console.log('id',this.props.id)
		// console.log('expenseName',expenseName)
		Tyan.doPostEvent({
			event: 'GetExpenseOrder',
			data: { id, taskName, expenseName },
			onEnd: ({ errorMessage, initValues基本信息, 部门, initValues发票明细, initValues费用明细, initValues出差费用明细, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, initValues发票明细, changedValues发票明细: {}, initValues费用明细, changedValues费用明细: {}, initValues出差费用明细, changedValues出差费用明细: {}, 部门, optionsParas })
				}
			}
		})
	}

	handlerSave = (classID = 0, name = '') => {
		const { readOnly } = this.props
		const { id, changedValues基本信息, expenseName, changedValues发票明细, changedValues费用明细, changedValues出差费用明细 } = this.state
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		const 报支类别 = getFormValue(this, '基本信息', '报支类别')
		const 状态 = getFormValue(this, '基本信息', '状态')
		var item = []
		if (报支名称 == '采购报支单') item = ['报支人', '采购单号', '付款方式', '付款期限', '报支类别', '供应商名称', '客户名称', '员工姓名']
		if (报支名称 == '一般报支单') item = ['报支人', '付款方式', '付款期限', '报支类别', '供应商名称', '客户名称', '员工姓名']
		if (报支名称 == '福利金报支单') item = ['报支人', '付款方式', '申请用途']
		if (报支名称 == '出差/外训报支单') item = ['币别', '报支人', '付款方式', '付款期限']
		if (报支名称 == '交际费报支单') item = ['币别', '报支人', '付款方式', '供应商或客户']
		if (报支名称 == '委外测试费报支单') item = ['币别', '报支人', '付款方式', '付款期限', '委外单位']
		for (var i = 0; i < item.length; i++) {
			if (item[i] == '供应商名称' && 报支类别 !== '供应商') continue
			if (item[i] == '客户名称' && 报支类别 !== '客户') continue
			if (item[i] == '员工姓名' && 报支类别 !== '员工') continue
			if (!getFormValue(this, '基本信息', item[i])) {
				Ext.toast(`${item[i]}必填`)
				return
			}
		}
		if (this.bChanged() && 状态 == '申请中')
			Tyan.doPostEvent({
				event: 'SaveExpenseOrder',
				data: { id, changedValues基本信息, expenseName, changedValues发票明细, changedValues费用明细, changedValues出差费用明细 },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('保存成功')
						this.handlerInitValue(id)
						if (name !== '') {
							const Comp = this.SettingsDiv[name]
							Tyan.pubForm.showDialog(name, props => <Comp {...props} readOnly={readOnly || 状态 !== '申请中'} id={classID} advanceExpenseID={id} onSave={() => this.handlerInitValue(id)} />)
						}
					}
				}
			})
		else {
			if (name !== '') {
				const Comp = this.SettingsDiv[name]
				Tyan.pubForm.showDialog(name, props => <Comp {...props} readOnly={readOnly || 状态 !== '申请中'} id={classID} advanceExpenseID={id} onSave={() => this.handlerInitValue(id)} />)
			}
		}
	}

	handlerClose = () => {
		//console.log('props', this.props)
		if (!this.bChanged()) {
			window.history.back()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteExpenseOrder',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						//onSave && onSave()
						window.history.back()
						//onClose && onClose()
					}
				}
			}))
	}

	handlerDeleteSelectAdvance = (advanceID) => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'DeleteSelectAdvance',
			data: { advanceID, id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.handlerInitValue(id)
				}
			}
		})
	}

	handlerDeleteEntrustedTestContractSelect = (contractID) => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'DeleteEntrustedTestContractSelect',
			data: { contractID, id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.handlerInitValue(id)
				}
			}
		})
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		var bSave = false
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		if (报支名称 == '交际费报支单')
			bSave = getFormValue(this, '基本信息', '供应商或客户')
		else if (报支名称 == '福利金报支单')
			bSave = getFormValue(this, '基本信息', '申请用途')
		else if (报支名称 == '委外测试费报支单') {
			bSave = getFormValue(this, '基本信息', '委外单位') /* &&
                getFormValue(this, '基本信息', '发票明细') && getFormValue(this, '基本信息', '发票明细').length > 0 */
		}
		else if (报支名称 == '采购报支单' || 报支名称 == '一般报支单') {
			const 报支类别 = getFormValue(this, '基本信息', '报支类别')
			bSave = getFormValue(this, '基本信息', '报支类别')
			if (报支类别 == '员工') {
				bSave = bSave && getFormValue(this, '基本信息', '员工姓名')
			}
			if (报支类别 == '供应商') {
				bSave = bSave && getFormValue(this, '基本信息', '供应商名称')
			}
			if (报支类别 == '客户') {
				bSave = bSave && getFormValue(this, '基本信息', '客户名称')
			}
			if (报支名称 == '采购报支单' && bSave) {
				bSave = getFormValue(this, '基本信息', '采购单号') /* &&
                getFormValue(this, '基本信息', '发票明细') && getFormValue(this, '基本信息', '发票明细').length > 0 */
			}
		}
		else if (报支名称 == '出差/外训报支单')
			bSave = getFormValue(this, '基本信息', '请假申请单号')
		if (报支名称 !== '福利金报支单' && bSave)
			bSave = getFormValue(this, '基本信息', '付款期限')
		// if (报支名称 != '委外测试费报支单' && bSave)
		//     bSave = getFormValue(this, '基本信息', '报支金额')
		if (报支名称 == '出差/外训报支单' || 报支名称 == '交际费报支单')
			return getFormValue(this, '基本信息', '币别') &&
				getFormValue(this, '基本信息', '报支人') &&
				getFormValue(this, '基本信息', '付款方式') && getFormValue(this, '基本信息', '用途说明') &&
				getFormValue(this, '基本信息', '附件') && getFormValue(this, '基本信息', '附件').length > 0 && bSave
		else return getFormValue(this, '基本信息', '币别') &&
			getFormValue(this, '基本信息', '报支人') &&
			getFormValue(this, '基本信息', '付款方式') && getFormValue(this, '基本信息', '用途说明') &&
			getFormValue(this, '基本信息', '附件') && getFormValue(this, '基本信息', '附件').length > 0 && bSave
	}

	handleRelatedPersonChange = (v) => {
		const { optionsParas } = this.state
		changeItemsValue(this, '基本信息', ['报支部门'], [optionsParas[v]])
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		if (报支名称 == '出差/外训报支单') {
			Tyan.doPostEvent({
				event: 'GetOutApplyNumber',
				data: { 报支人: v },
				onEnd: ({ errorMessage, optionsParas: newOptionsParas }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						this.setState({ optionsParas: { ...optionsParas, ...newOptionsParas } })
						this.handleGetBankInfo()
					}
				}
			})
		} else {
			const 报支类别 = getFormValue(this, '基本信息', '报支类别')
			if (报支类别 == '员工' && 报支名称 == '一般报支单')
				changeItemsValue(this, '基本信息', ['员工姓名'], [v])
			if (报支名称 !== '采购报支单')
				this.handleGetBankInfo()
		}
	}

	handleGetOptionsParas = (type, id, v) => {
		const { optionsParas } = this.state
		Tyan.doPostEvent({
			event: 'GetOptionsParas',
			data: { type, id, v },
			onEnd: ({ errorMessage, optionsParas: newOptionsParas, model }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ optionsParas: { ...optionsParas, ...newOptionsParas } })
					this.handleGetBankInfo()
				}
			}
		})
	}

	handleGetBankInfo = () => {
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		var person = ''
		var supplier = ''
		var customer = ''
		if (报支名称 == '委外测试费报支单')
			supplier = getFormValue(this, '基本信息', '委外单位')
		else {
			if (报支名称 == '采购报支单' || 报支名称 == '一般报支单') {
				const 报支类别 = getFormValue(this, '基本信息', '报支类别')
				if (报支类别 == '员工')
					person = getFormValue(this, '基本信息', '员工姓名')

				else if (报支类别 == '供应商')
					supplier = getFormValue(this, '基本信息', '供应商名称')

				else if (报支类别 == '客户')
					customer = getFormValue(this, '基本信息', '客户名称')
			} else
				person = getFormValue(this, '基本信息', '报支人')
		}

		Tyan.doPostEvent({
			event: 'GetBankInfo',
			data: { person, supplier, customer },
			onEnd: ({ errorMessage, bankInfo }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['银行账号', '开户银行', '电话', '手机', '邮箱'], [bankInfo.银行账号, bankInfo.开户银行, bankInfo.电话, bankInfo.手机, bankInfo.邮箱])
					if (supplier != '')
						changeItemsValue(this, '基本信息', ['付款期限'], [bankInfo.付款条件])
				}
			}
		})
	}

	handleAdvanceAmountChange = (v) => {
		const 预支金额 = getFormValue(this, '基本信息', '预支金额')
		changeItemsValue(this, '基本信息', ['支付金额'], [v - 预支金额])
	}

	handleAdvanceType = (v, id) => {
		const { optionsParas, expenseName } = this.state
		const 名称 = getFormValue(this, '基本信息', '名称')
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		Tyan.doPostEvent({
			event: 'GetExpenseBank',
			data: { expenseName, 报支类别: this.state.changedValues基本信息.报支类别, 名称: 名称, 报支名称 },
			onEnd: ({ errorMessage, bankInfo, options }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['开户银行'], [bankInfo.开户银行])
					changeItemsValue(this, '基本信息', ['银行账号'], [bankInfo.银行账号])
					this.setState({ optionsParas: { ...optionsParas, '名称': options } })
				}
			}
		})
	}

	handleAccountBank = (v, 报支名称) => {
		const { expenseName } = this.state
		Tyan.doPostEvent({
			event: 'GetExpenseBank',
			data: { 名称: v, expenseName, 报支类别: this.state.changedValues基本信息.报支类别, 报支名称 },
			onEnd: ({ errorMessage, bankInfo, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['开户银行'], [bankInfo.开户银行])
					changeItemsValue(this, '基本信息', ['银行账号'], [bankInfo.银行账号])
				}
			}
		})
	}

	handleCurrencyNameChange = (v) => {
		const 申请时间 = getFormValue(this, '基本信息', '申请时间')
		Tyan.doPostEvent({
			event: 'GetExchangeRateByCurrency',
			data: { 币别: v, 申请时间 },
			onEnd: ({ errorMessage, ExchangeRate }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
				}
			}
		})
	}

	handlerExpenseExport = () => {
		const { id } = this.state
		exportFile(null, null, "ExpenseExport?id=" + id)
	}

	handleSelectOrderNoDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <SelectPurchaseOrderNoDiv {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} onlyView={true} />)
	}

	handleOutApplyNumberDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <SelectOutApplyNumberDiv {...props} relatedPerson={initValues.报支人} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
	}

	handleSelectedChanged = (name, value) => {
		changeItemsValue(this, '基本信息',
			[name],
			[value],
		)
	}

	// handlerGetRequisition = () => {
	//     const 请购单号 = getFormValue(this, '基本信息', `采购单号`)
	//     Tyan.doPostEvent({
	//         event: 'GetRequisitionID',
	//         data: { 请购单号 },
	//         onEnd: ({ errorMessage, ids }) => {
	//             if (errorMessage) {
	//                 Tyan.pubForm.showError(errorMessage)
	//             }
	//             if (ids.length > 1) {
	//                 Tyan.pubForm.showDialog('采购信息', props => <RequisitionBatchDiv {...props} ids={ids} />)
	//             }
	//             else {
	//                 Tyan.pubForm.showDialog('采购信息', props => <RequisitionDiv {...props} id={ids[0]} />)
	//             }
	//         }
	//     })
	// }

	handlerGetLeaveApplyDetail = (outReason) => {
		const 申请编号 = getFormValue(this, '基本信息', `请假申请单号`)
		if (outReason == '外训')
			Tyan.doPostEvent({
				event: 'GetOutTrainDetail',
				data: { 申请编号 },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					Tyan.pubForm.showDialog('外训申请单', props => <FlowRecordDetail {...props} id={id} type={'show'} />)
				}
			})
		else
			Tyan.doPostEvent({
				event: 'GetLeaveApplyDetail',
				data: { 申请编号 },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					Tyan.pubForm.showDialog('请假申请单', props => <LeaveApplyDetail {...props} id={id} notSubmit={true} />)
				}
			})
	}

	handlerAddInfo = (type) => {
		if (type == '发票明细') {
			addListItem(this, {}, '发票明细', '发票明细')
			Ext.toast(`添加成功！`); return
		} else if (type == '费用明细') {
			addListItem(this, {}, '费用明细', '费用明细')
		} else if (type == '出差费用明细') {
			addListItem(this, {}, '出差费用明细', '出差费用明细')
		}
	}

	handlerDeleteInfo = (id, type) => {
		if (type == '发票明细') {
			deleteListItem(this, '发票明细', '发票明细', id)
		} else if (type == '费用明细') {
			deleteListItem(this, '费用明细', '费用明细', id)
		} else if (type == '出差费用明细') {
			deleteListItem(this, '出差费用明细', '出差费用明细', id)
		}
	}

	AutoCalculationOutsource = (id) => {
		const 原币含税金额 = getFormValue(this, '发票明细', `发票明细[${id}].原币含税金额`)
		const 汇率 = getFormValue(this, '基本信息', `汇率`)
		const 税率 = getFormValue(this, '发票明细', `发票明细[${id}].税率`)

		var 原币未税金额 = 0
		var 本币含税金额 = 0
		var 本币未税金额 = 0
		var d税率 = 0
		if (税率) {
			if (税率 == 'CN01：增值税13%')
				d税率 = 0.13
			else if (税率 == 'CN02：增值税9%')
				d税率 = 0.09
			else if (税率 == 'CN03：增值税6%')
				d税率 = 0.06
			else if (税率 == 'CN04：增值税3%')
				d税率 = 0.03
			else if (税率 == 'CN05：增值税1%')
				d税率 = 0.01
		}
		if (汇率 && 原币含税金额) {
			// 原币未税金额 = 原币含税金额 * (1 - d税率)
			// 本币含税金额 = 原币含税金额 * 汇率
			// 本币未税金额 = 原币含税金额 * 汇率 * (1 - d税率)
			原币未税金额 = 原币含税金额 / (1 + d税率)
			本币含税金额 = 原币含税金额 * 汇率
			本币未税金额 = (原币含税金额 * 汇率) / (1 + d税率)
		}
		changeItemsValue(this, '发票明细', [`发票明细[${id}].原币未税金额`, `发票明细[${id}].本币含税金额`, `发票明细[${id}].本币未税金额`], [原币未税金额, 本币含税金额, 本币未税金额])
	}

	AutoCalculationExpenseInfo = (id) => {
		const 金额 = getFormValue(this, '费用明细', `费用明细[${id}].金额`)
		const 汇率 = getFormValue(this, '费用明细', `费用明细[${id}].汇率`)
		var 人民币金额 = 金额
		if (汇率) {
			人民币金额 = 金额 * 汇率
		}
		changeItemsValue(this, '费用明细', [`费用明细[${id}].人民币金额`], [人民币金额])
	}

	handleExpenseInfoNameChange = (id) => {
		const 申请时间 = getFormValue(this, '基本信息', '申请时间')
		const 币别 = getFormValue(this, '费用明细', `费用明细[${id}].币别`)

		Tyan.doPostEvent({
			event: 'GetExchangeRateByCurrency',
			data: { 币别, 申请时间 },
			onEnd: ({ errorMessage, ExchangeRate }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '费用明细', [`费用明细[${id}].汇率`], [ExchangeRate])
					this.AutoCalculationExpenseInfo(id)
				}
			}
		})
	}


	fieldset基本信息 = () => {
		const { readOnly } = this.props
		const { optionsParas } = this.state
		const { 部门 } = this.state
		const 状态 = getFormValue(this, '基本信息', '状态')
		const 报支类别 = getFormValue(this, '基本信息', '报支类别')
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		const 采购单号 = getFormValue(this, '基本信息', '采购单号')
		const 预支金额 = getFormValue(this, '基本信息', '预支金额')
		const 委托总和 = getFormValue(this, '基本信息', '委托总和')
		const 报支人 = getFormValue(this, '基本信息', '报支人')
		const { list } = getListItems(this, '基本信息', '成本承担部门')
		const { list: list1 } = getListItems(this, '基本信息', '费用明细')
		const { list: list2 } = getListItems(this, '基本信息', '发票明细')
		const { list: list3 } = getListItems(this, '基本信息', '出差费用明细')
		const 请购单号 = getFormValue(this, '基本信息', `采购单号`)
		const 请假单号 = getFormValue(this, '基本信息', `请假申请单号`)
		const 外出原因 = getFormValue(this, '基本信息', `外出原因`)
		const 交际对象 = getFormValue(this, '基本信息', `交际对象`)
		const { list: list4 } = getListItems(this, '基本信息', '委外测试合同')
		// const 选择报支类别 =  getFormValue(this, '基本信息', '选择报支类别')
		const { list: list发票明细 } = Tyan.utility.getListItems(this, '发票明细', '发票明细')
		const { list: list费用明细 } = Tyan.utility.getListItems(this, '费用明细', '费用明细')
		const { list: list出差费用明细 } = Tyan.utility.getListItems(this, '出差费用明细', '出差费用明细')

		var fields = [

		]

		var top = [
			// { _radio: '报支类别', name: '选择报支类别', itemMinWidth: 125, minWidth: '95%', items: ['采购报支单', '一般报支单', '福利金报支单', '出差/外训报支单', '交际费报支单', '委外测试费报支单'], required: true, cdt:() => 选择报支类别 != '' }

			{ _text: '报支单号', disabled: true },
			{ _datetime: '申请时间', disabled: true, },
			{ _text: '申请人', disabled: true },
			{ _text: '申请部门', disabled: true },
		]
		var body = [
		]
		var bottom = [
		]
		var follow = [
		]
		if (报支名称 == '采购报支单' || 报支名称 == '一般报支单') {
			top.push({ _select: '报支人', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额 && 报支类别 == '员工' })
			top.push({ _text: '报支部门', disabled: true, })
			//采购报支单-采购多选切打开采购单，8/26
			if (报支名称 == '采购报支单')
				top.push({
					_group: '', margin: 0, items: [
						{
							_text: '采购单号', required: true, disabled: true, minWidth: '20%', tooltip: 请购单号,
							button: { text: "...", handler: (orderNo) => this.handleSelectOrderNoDiv({ title: '选择采购单号', orderNo, bReadOnly: readOnly || 状态 !== '申请中' }, (orderNo) => this.handleSelectedChanged('采购单号', orderNo)) }
						},
						// {
						//     _buttons: [
						//         {
						//             _button: '查看', icon: 'info-circle', ui: '', margin: 0,
						//             handler: () => this.handlerGetRequisition(), disabled: !请购单号 || 请购单号 == '',
						//         },
						//     ], width: 100, margin: 0,
						// },
					]
				})

			body.push({ _select: '币别', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', onChange: (v) => this.handleAdvanceAmountChange(v), textAlign: 'left', })
			body.push({ _float: '预支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', required: true })
			bottom.push({ _select: '付款期限', required: true })
			bottom.push({ _select: '报支类别', disabled: 预支金额, onChange: (v) => this.handleAdvanceType(v, this.props.id) })
			// fields.push({ _radio: '安环费用支出', })
			if (报支类别 == '员工') {
				bottom.push({ _select: '员工姓名', required: true, disabled: 预支金额, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('员工姓名', this.props.id, v) })
			}
			if (报支类别 == '供应商') {
				bottom.push({ _select: '供应商名称', required: true, disabled: 预支金额, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('供应商名称', this.props.id, v) })
			}
			if (报支类别 == '客户') {
				bottom.push({ _select: '客户名称', required: true, disabled: 预支金额, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('客户名称', this.props.id, v) })
			}
			bottom.push({ _select: '名称', name: '名称', editable: true, forceSelection: false, cdt: () => 报支名称 == "一般报支单" && 报支类别 == "其他", onChange: (v) => this.handleAccountBank(v, 报支名称) })
			bottom.push({ _text: '开户银行', })
			bottom.push({ _text: '银行账号', })
			// fields.push({ _radio: '采购类型', })

			bottom.push({ _files: '附件', required: true })


		}

		if (报支名称 == '福利金报支单') {
			top.push({ _select: '报支人', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', disabled: true })
			top.push({ _radio: '申请用途', required: true })

			body.push({ _select: '币别', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', onChange: (v) => this.handleAdvanceAmountChange(v), textAlign: 'left', })
			body.push({ _float: '预支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', required: true })
			bottom.push({ _select: '付款期限', required: true })
			bottom.push({ _text: '开户银行', })
			bottom.push({ _text: '银行账号', })
			bottom.push({ _files: '附件', required: true })
		}
		if (报支名称 == '出差/外训报支单') {
			top.push({ _select: '报支人', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', disabled: true })
			top.push({
				_group: '', margin: 0, items: [
					{
						_text: '出差/外训申请单号', name: '请假申请单号', disabled: true, minWidth: '20%', required: true,
						button: { text: "...", handler: () => this.handleOutApplyNumberDiv({ title: '选择出差/外训申请单号', 报支人 }, (outApplyNumber, outReason) => { this.handleSelectedChanged('请假申请单号', outApplyNumber), this.handleSelectedChanged('外出原因', outReason) }) }
					},
					{
						_buttons: [
							{
								_button: '查看', icon: 'info-circle', ui: '', margin: 0,
								handler: () => this.handlerGetLeaveApplyDetail(外出原因), disabled: !请假单号 || 请假单号 == '',
								cdt: () => false
							},
						], width: 100, margin: 0,
					},
				]
			})

			body.push({ _select: '币别', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '预支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', required: true })
			bottom.push({ _select: '付款期限', required: true })
			bottom.push({ _text: '开户银行', })
			bottom.push({ _text: '银行账号', })
			// fields.push({
			//     _text: '请假申请单号', disabled: true, minWidth: '45%',
			//     button: { text: "...", handler: () => this.handleOutApplyNumberDiv({ title: '选择请假申请单号', 报支人 }, (outApplyNumber) => this.handleSelectedChanged('请假申请单号', outApplyNumber)) }
			// })
			//fields.push({ _select: '请假申请单号', })
			bottom.push({ _files: '附件', required: true })
			bottom.push({
				_group: '', margin: 0, padding: 0, items: [].concat({
					_buttons: [
						{ _button: '添加', icon: '', ui: '', margin: 0, handler: () => this.handlerAddInfo('出差费用明细'), cdt: () => 状态 == '申请中' }
					], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
				}).concat(list出差费用明细.map((o, iNo) => {
					const _list = { listName: '出差费用明细', id: o.id }
					return {
						_border: `出差费用明细${iNo + 1}`, name: `出差费用明细[${o.id}]`, disabled: 状态 != '申请中', list: _list, margin: '5 0 15 0', minWidth: '90%', fieldset: '出差费用明细', items: [
							{ _date: '开始日期', required: true },
							{ _date: '结束日期', required: true },
							{ _text: '出发地', required: true },
							{ _text: '目的地', required: true },
							{ _float: '飞机票', },
							{ _float: '火车票', },
							{ _float: '船票', },
							{ _float: '公交', },
							{ _float: '出租', },
							{ _float: '公里补助', },
							{ _float: '停车费', },
							{ _checkbox: '膳食费', itemMinWidth: 80, items: ['早：10元', '中：25元', '晚：25元',], required: false, },
							{ _float: '其他膳食费', },
							{ _float: '住宿费', },
							{ _float: '其他', },
							{
								_buttons: [
									{
										_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0,
										handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(o.id, '出差费用明细') }), cdt: () => 状态 == '申请中'
									}
								], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
							}
						]
					}
				})
				)
			})
		}
		if (报支名称 == '交际费报支单') {
			top.push({ _select: '报支人', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', disabled: true })

			body.push({ _select: '币别', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '预支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', disabled: true, textAlign: 'left', })
			body.push({ _radio: '交际对象', items: ['供应商', '客户'] })
			body.push({ _select: '供应商', name: '供应商或客户', options: optionsParas.供应商名称, cdt: () => 交际对象 != '客户', required: true, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('供应商或客户', this.props.id, v) })
			body.push({ _select: '客户名称', name: '供应商或客户', options: optionsParas.客户名称, cdt: () => 交际对象 == '客户', required: true, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('供应商或客户', this.props.id, v) })
			body.push({ _select: '参加人员', multiSelect: true, editable: true })
			body.push({ _number: '总人数', minWidth: '90%' })
			body.push({ _text: '用途说明', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', required: true })
			bottom.push({ _select: '付款期限', required: true })
			bottom.push({ _text: '开户银行', })
			bottom.push({ _text: '银行账号', })
			bottom.push({ _files: '附件', required: true })
			bottom.push({
				_group: '', margin: 0, padding: 0, items: [].concat({
					_buttons: [
						{ _button: '添加', icon: '', ui: '', margin: 0, handler: () => this.handlerAddInfo('费用明细'), cdt: () => 状态 == '申请中' }
					], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
				}).concat(list费用明细.map((o, iNo) => {
					const _list = { listName: '费用明细', id: o.id }
					return {
						_border: `费用明细${iNo + 1}`, name: `费用明细[${o.id}]`, disabled: 状态 != '申请中', list: _list, margin: '5 0 15 0', minWidth: '90%', fieldset: '费用明细', items: [
							{ _date: '日期', required: true },
							{ _select: '类别', required: true },
							{ _select: '币别', onChange: () => this.handleExpenseInfoNameChange(o.id), required: true },
							{ _float: '金额', onChange: () => this.AutoCalculationExpenseInfo(o.id), required: true },
							{ _float: '汇率', disabled: true },
							{ _float: '人民币金额', disabled: true },
							{ _text: '备注', maxRows: 3 },
							{
								_buttons: [
									{
										_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0,
										handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(o.id, '费用明细') }), cdt: () => 状态 == '申请中'
									}
								], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
							}
						]
					}
				})
				)
			})
		}
		if (报支名称 == '委外测试费报支单') {
			const { list: optionsList } = getListFromValues('部门', null, 部门, {})
			top.push({ _select: '报支人', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', disabled: true })
			top.push({ _html: '委外项目成本总和', name: '委外总和', minWidth: '95%', disabled: true, style: { color: 'darkgreen', fontWeight: 'bold' } })
			top.push({ _html: '委外项目收入总和', name: '合同总和', minWidth: '95%', disabled: true, style: { color: 'darkgreen', fontWeight: 'bold' } })

			body.push({ _select: '币别', onChange: (v) => this.handleCurrencyNameChange(v) })
			body.push({ _float: '汇率', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', required: true, onChange: (v) => this.handleAdvanceAmountChange(v), textAlign: 'left', })
			body.push({ _float: '预支金额', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', maxRows: 4, required: true })

			bottom.push({ _select: '委外单位', required: true, editable: true, forceSelection: false, disabled: 委托总和 || list4.length > 0, onChange: () => this.handleGetBankInfo() })
			bottom.push({ _select: '付款方式', required: true })
			bottom.push({ _select: '付款期限', required: true })
			bottom.push({ _text: '开户银行', })
			bottom.push({ _text: '银行账号', })
			bottom.push({ _files: '附件', required: true })
			bottom.push({
				_group: '', margin: 0, padding: 0, items: [].concat({
					_buttons: [
						{ _button: '添加 <font style=\'color:red;\'>*</font>', icon: '', ui: '', margin: 0, handler: () => this.handlerAddInfo('发票明细'), cdt: () => 状态 == '申请中' }
					], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
				}).concat(list发票明细.map((o, iNo) => {
					const _list = { listName: '发票明细', id: o.id }
					return {
						_border: `发票明细${iNo + 1}`, name: `发票明细[${o.id}]`, disabled: 状态 != '申请中', list: _list, margin: '5 0 15 0', minWidth: '90%', fieldset: '发票明细', items: [
							{ _text: '发票号码', required: true },
							{ _date: '发票日期', required: true },
							{ _float: '原币含税金额', onChange: () => this.AutoCalculationOutsource(o.id), required: true },
							{ _select: '税率', onChange: () => this.AutoCalculationOutsource(o.id), required: true },
							{ _float: '原币未税金额' },
							{ _float: '本币含税金额' },
							{ _float: '本币未税金额' },
							{ _text: '备注' },
							{
								_buttons: [
									{
										_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0,
										handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(o.id, '发票明细') }), cdt: () => 状态 == '申请中'
									}
								], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
							}
						]
					}
				})
				)
			})
		}

		// follow.push({
		//     _grid: '成本承担部门', name: '成本承担部门', rowNumbers: true, minRows: 1, maxRows: 999, minWidth: '95%', 
		//     columns: [
		//         { _text: '成本承担部门', flex: 4 },
		//         { _float: '部门分摊金额', flex: 2 },
		//         { _text: '部门分摊比例', flex: 2 },
		//     ],
		//     buttons: [
		//         { _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '成本承担部门'), cdt: () => !readOnly && 状态 == '申请中' },
		//     ],
		//     onDoubleTap: data => this.handlerSave(data.id, '成本承担部门')
		// })

		fields.push({ _border: ' ', margin: '0px 0px 0px 0px', padding: '0px 0px 0px 0px', minWidth: '82%', items: top, })
		fields.push({ _border: ' ', margin: '0px 0px 0px 0px', padding: '0px 0px 0px 0px', minWidth: '82%', items: body, })
		fields.push({ _border: ' ', margin: '0px 0px 0px 0px', padding: '0px 0px 0px 0px', minWidth: '82%', items: bottom, })
		//fields.push({ _group: ' ', margin: '0px 0px 0px 0px', padding:  '0px 0px 0px 0px', minWidth: '82%', items: follow, })

		return fields
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	// fieldset签核流程 = () => {
	//     return [
	//         { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	// }

	// fieldset预支申请单 = () => {
	//     const { readOnly } = this.props
	//     const 状态 = getFormValue(this, '基本信息', '状态')
	//     return [
	//         {
	//             _grid: '', name: '预支申请单', rowNumbers: true, height: '100%', minWidth: '95%',
	//             columns: [
	//                 { _text: '预支申请单号', flex: 1.5 },
	//                 { _float: '预支金额', flex: 1 },
	//                 { _date: '申请日期', flex: 1.2 },
	//                 { _text: '申请人', flex: 1 },
	//                 { _text: '用途说明', flex: 1 },
	//                 {
	//                     _button: '', icon: 'trash-o', ui: 'decline', hidden: (data) => readOnly || 状态 !== '申请中',
	//                     handler: (that, data, record) => Tyan.pubForm.showConfirm('确定要删除？', () => this.handlerDeleteSelectAdvance(data.id)),
	//                     flex: 0.5
	//                 },
	//             ],
	//             buttons: [
	//                 { _button: '选择...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '预支申请单'), cdt: () => !readOnly && 状态 == '申请中' },
	//             ],
	//             onDoubleTap: data => Tyan.pubForm.showDialog('预支申请单', props => <AdvanceOrder {...props} id={data.id} readOnly={true} />)
	//         }
	//     ]
	// }

	// fieldset委外测试合同 = () => {
	//     const { readOnly } = this.props
	//     const 状态 = getFormValue(this, '基本信息', '状态')
	//     return [
	//         {
	//             _grid: '', name: '委外测试合同', rowNumbers: true, height: '100%', minWidth: '95%',
	//             columns: [
	//                 { _text: '合同编号', flex: 2.3 },
	//                 { _text: '样品名称', flex: 1.5 },
	//                 { _text: '测试项目', flex: 1.5 },
	//                 { _text: '业务员', flex: 1.5 },
	//                 { _float: '委外项目成本', name: '委外金额', flex: 1.5 },
	//                 { _float: '委外项目收入', name: '合同金额', flex: 1.5 },
	//                 {
	//                     _button: ' ', icon: 'trash-o', ui: 'decline', hidden: (data) => readOnly || 状态 !== '申请中',
	//                     handler: (that, data, record) => Tyan.pubForm.showConfirm('确定要删除？', () => this.handlerDeleteEntrustedTestContractSelect(data.id)),
	//                     flex: 0.5
	//                 },
	//             ],
	//             buttons: [
	//                 { _button: '选择...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '委外测试合同'), cdt: () => !readOnly && 状态 == '申请中' },
	//             ],
	//         }
	//     ]
	// }

	render() {
		const { showMessage: Message, showBody: Body, readOnly } = this.props
		const { errorMessage, id, initValues基本信息, } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 报支名称, 状态, 提交时间 } = initValues基本信息
		return <Body data={this}/*  maxWidth="100%" */
			controls={
				readOnly ? [
					//{ _button: '打印', icon: 'print', handler: this.handlerExpenseExport, disabled: this.bChanged(), cdt: () => 状态 == '已完成' || 状态 == '报支确认' || 状态 == '金额支付' || 状态 == '报支打印' },
					{ _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
				] : [
					{ _flow: 'ExpenseFlow', disabled: this.bChanged() || !this.canSave(), cdt: () => id > 0, onFinish: () => window.history.back() },
					// 1)改为只在报支单的状态名称为“报支打印”或“金额支付”或“报支确认”或“已完成”时显示
					//{ _button: '打印', icon: 'print', handler: this.handlerExpenseExport, cdt: () => id > 0, disabled: this.bChanged(), cdt: () => 状态 == '已完成' || 状态 == '报支打印' || 状态 == '金额支付' || 状态 == '报支确认' },
					{ _button: '保存', icon: '', handler: () => this.handlerSave(), disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 == '申请中' },
					{ _button: '删除', icon: '', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
					{ _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: 报支名称, name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中', docked: 'top', height: '68%', },
					{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },

					// {
					//     _fieldsets: [
					//         { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
					//         // { title: '委外测试合同', name: '基本信息', _fieldset: this.fieldset委外测试合同(), fullblock: true, cdt: () => 报支名称 == '委外测试费报支单' },
					//         // { title: '预支申请单', name: '基本信息', _fieldset: this.fieldset预支申请单(), fullblock: true },
					//         // { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
					//     ], docked: 'follow', width: '40%',
					// }
				]
			}
		/>
	}
}

export default connect()(ExpenseApply)